export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-A1-A2.ede174cb.jpg";